import { render, staticRenderFns } from "./WelcomeRepresentative.vue?vue&type=template&id=9234f22c&scoped=true&"
import script from "./WelcomeRepresentative.vue?vue&type=script&lang=ts&"
export * from "./WelcomeRepresentative.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9234f22c",
  null
  
)

export default component.exports